function resolveEndpoint(endpoint: string): string {
  // In a browser context, relative URLs work fine
  if (typeof window !== 'undefined') return endpoint;

  // Server-side: fetch requires an absolute URL
  const base =
    process.env.NEXT_PUBLIC_APP_URL ||
    (process.env.VERCEL_URL ? `https://${process.env.VERCEL_URL}` : 'http://localhost:3000');

  return `${base}${endpoint}`;
}

export async function callAIEndpoint(endpoint: string, payload: object) {
  try {
    const url = resolveEndpoint(endpoint);
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    let data: any = {};
    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
      const text = await response.text();
      if (text.trim()) {
        try {
          data = JSON.parse(text);
        } catch {
          data = { error: `Invalid JSON response: ${text.slice(0, 100)}` };
        }
      }
    }

    if (!response.ok || data.error) {
      const status = response.status;
      const isTransient = status === 502 || status === 503 || status === 504;
      const errMsg = data.error || `Request failed: ${status}`;
      if (isTransient) {
        console.warn(`AI endpoint transient error (${status}):`, errMsg);
      } else {
        console.error('API Route Error:', {
          error: errMsg,
          details: data.details || '',
        });
      }
      throw new Error(errMsg);
    }

    return data;
  } catch (error) {
    // Only log non-transient errors to avoid console noise from temporary AI provider outages
    const isTransient =
      error instanceof Error &&
      (error.message.includes('502') || error.message.includes('503') || error.message.includes('504'));
    if (!isTransient) {
      console.error('API request error:', error);
    }
    throw error;
  }
}
